import Enum from './enum'

export default Object.assign({}, Enum, {
  Avatar1: 1,
  Avatar2: 2,
  Avatar3: 3,
  Avatar4: 4,
  Avatar5: 5,
  Avatar6: 6,
  Avatar7: 7,
  Avatar8: 8,
  Avatar9: 9,
  Avatar10: 10,
  Avatar11: 11,
  Avatar12: 12,
  Avatar13: 13,
  Avatar14: 14,
  Avatar15: 15,

  icon (value) {

    switch (+value) {
      case this.Avatar1:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava1.png'
      case this.Avatar2:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava2.png'
      case this.Avatar3:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava3.png'
      case this.Avatar4:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava4.png'
      case this.Avatar5:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava5.png'
      case this.Avatar6:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava6.png'
      case this.Avatar7:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava7.png'
      case this.Avatar8:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava8.png'
      case this.Avatar9:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava9.png'
      case this.Avatar10:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava10.png'
      case this.Avatar11:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava11.png'
      case this.Avatar12:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava12.png'
      case this.Avatar13:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava13.png'
      case this.Avatar14:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava14.png'
      case this.Avatar15:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava15.png'
    }

    return ''
  }
})
